export default {
    "lyrics": [
        {
            "characters": ["startup"],
            "time": "00:01",
            "lyric": "I'm grateful for your care"
        },
        {
            "characters": ["startup"],
            "time": "00:05",
            "lyric": "But didn't the valley bank say they had liquidity to spare?"
        },
        {
            "characters": ["vc"],
            "time": "00:10",
            "lyric": "Who knows children? Are you willing to bet?"
        },
        {
            "characters": ["startup"],
            "time": "00:12",
            "lyric": "-"
        },
        {
            "characters": ["vc"],
            "time": "00:14",
            "lyric": "Isn't their job to put people at ease and not despair?"
        },
        {
            "characters": ["startup"],
            "time": "00:16",
            "lyric": "-"
        },
        {
            "characters": ["startup"],
            "time": "00:20",
            "lyric": "At the end of the week"
        },
        {
            "characters": ["vc"],
            "time": "00:21",
            "lyric": "-"
        },
        {
            "characters": ["startup"],
            "time": "00:22",
            "lyric": "Just as the valley feared"
        },
        {
            "characters": ["startup"],
            "time": "00:25",
            "lyric": "They valley bank started toppling"
        },
        {
            "characters": ["startup", "vc"],
            "time": "00:27",
            "lyric": "The government came knocking"
        },
        {
            "characters": ["startup"],
            "time": "00:39",
            "lyric": "Heroes or evil"
        },
        {
            "characters": ["vc"],
            "time": "00:40",
            "lyric": "-"
        },
        {
            "characters": ["startup"],
            "time": "00:41",
            "lyric": "Up to you to decide"
        },
        {
            "characters": ["startup"],
            "time": "00:43",
            "lyric": "Talk to the lord (2x)"
        },
        {
            "characters": ["startup"],
            "time": "00:45",
            "lyric": "He will know your side"
        },
        {
            "characters": ["startup"],
            "time": "00:48",
            "lyric": "Heroes or evil"
        },
        {
            "characters": ["startup"],
            "time": "00:50",
            "lyric": "Up to you to decide"
        },
        {
            "characters": ["startup"],
            "time": "00:51",
            "lyric": "Talk to the lord (2x)"
        },
        {
            "characters": ["startup"],
            "time": "00:53",
            "lyric": "Only god knows who's right"
        },
        {
            "characters": ["vc"],
            "time": "00:56",
            "lyric": "Right!"
        },
        {
            "characters": ["vc"],
            "time": "00:58",
            "lyric": "The valley bank was badly wounded from mismanaging its investments"
        },
        {
            "characters": ["vc"],
            "time": "01:02",
            "lyric": "Controlling people's faith on them was just too much 🤷‍♂️"
        },
        {
            "characters": ["startup"],
            "time": "01:04",
            "lyric": "The last domino piece: we ran to the bank"
        },
        {
            "characters": ["vc"],
            "time": "01:07",
            "lyric": "Welcome to the celebration of the life of the valley bank"
        },
        {
            "characters": ["vc"],
            "time": "01:11",
            "lyric": "Who went to be with the Lord today. In the valley money won't be raining like yesterday"
        },
        {
            "characters": ["startup"],
            "time": "01:16",
            "lyric": "They believed in us"
        },
        {
            "characters": ["vc"],
            "time": "01:18",
            "lyric": "They collapsed"
        },
        {
            "characters": ["startup"],
            "time": "01:19",
            "lyric": "They collapsed"
        },
        {
            "characters": ["startup"],
            "time": "01:20",
            "lyric": "How can this happen?"
        },
        {
            "characters": ["vc"],
            "time": "01:23",
            "lyric": "They relaxed"
        },
        {
            "characters": ["startup"],
            "time": "01:23",
            "lyric": "But who's the"
        },
        {
            "characters": ["vc", "startup"],
            "time": "01:24",
            "lyric": "Heros or evil"
        },
        {
            "characters": ["startup"],
            "time": "01:26",
            "lyric": "Up to you to decide"
        },
        {
            "characters": ["vc"],
            "time": "01:28",
            "lyric": "-"
        },
        {
            "characters": ["startup"],
            "time": "01:29",
            "lyric": "Talk to the lord (2x)"
        },
        {
            "characters": ["startup"],
            "time": "01:31",
            "lyric": "He'll know your side"
        },
        {
            "characters": ["vc", "startup"],
            "time": "01:33",
            "lyric": "Heros or evil"
        },
        {
            "characters": ["startup"],
            "time": "01:36",
            "lyric": "Up to you to decide"
        },
        {
            "characters": ["startup"],
            "time": "01:38",
            "lyric": "Talk to the lord (2x)"
        },
        {
            "characters": ["startup"],
            "time": "01:40",
            "lyric": "Only god knows who's right"
        },
        {
            "characters": ["startup"],
            "time": "01:46",
            "lyric": "It was taken over by regulators at the end of the week"
        },
        {
            "characters": ["startup"],
            "time": "01:52",
            "lyric": "Leaving almost $200 billion that might've gone with the wind"
        },
        {
            "characters": ["startup"],
            "time": "01:57",
            "lyric": "Now who's the"
        },
        {
            "characters": ["vc", "startup"],
            "time": "02:03",
            "lyric": "Heros or evil"
        },
        {
            "characters": ["vc"],
            "time": "02:04",
            "lyric": "Harmonizes uuuh"
        },
        {
            "characters": ["startup"],
            "time": "02:05",
            "lyric": "Up to you to decide"
        },
        {
            "characters": ["startup"],
            "time": "02:06",
            "lyric": "Talk to the lord (2x)"
        },
        {
            "characters": ["vc"],
            "time": "02:08",
            "lyric": "-"
        },
        {
            "characters": ["startup"],
            "time": "02:10",
            "lyric": "He'll know your side"
        },
        {
            "characters": ["vc", "startup"],
            "time": "02:12",
            "lyric": "Heros or evil"
        },
        {
            "characters": ["startup"],
            "time": "02:13",
            "lyric": "Up to you to decide"
        },
        {
            "characters": ["startup"],
            "time": "02:14",
            "lyric": "Talk to the lord (2x)"
        },
        {
            "characters": ["startup"],
            "time": "02:18",
            "lyric": "Only god knows who's right"
        },
    ]
}
